// The cart can be re-rendered through AJAX, so the select is looked up when needed and events are delegated.
function getSelectBox() {
  return document.getElementById('delivery_time');
}

function postData() {
  const selectBox = getSelectBox();
  if (!selectBox) return;

  const selectedValue = selectBox.value;
  const attributes = {
    attributes: {
      'delivery_time': selectedValue
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attributes),
  })
    .then(response => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });
}

// Checkout guard: third-party checkout scripts can send the customer to /checkout straight from the click, so the
// form's `required` validation never runs. Stop the click (capture phase on window, ahead of their handlers)
// until a delivery time is chosen (and, for convenience-store pickup, until it is 不指定).
const GUARD_ERROR_ID = 'cart-checkout-guard-error';
const CVS_SHIPPING_METHOD = '超商取貨';
const CVS_DELIVERY_TIME = '不指定';

function getDeliveryTimeError(form) {
  const selectBox = getSelectBox();
  if (!selectBox) return '';
  if (selectBox.value === '') return '請選擇送貨時間段';

  const method = form.querySelector('[name="attributes[運送方法(ShippingMethod)]"]');
  if (method && method.value === CVS_SHIPPING_METHOD && selectBox.value !== CVS_DELIVERY_TIME) {
    return '超商取貨請選擇「不指定」';
  }
  return '';
}

function clearGuardError() {
  const existing = document.getElementById(GUARD_ERROR_ID);
  if (existing) existing.remove();

  const selectBox = getSelectBox();
  if (!selectBox) return;
  selectBox.removeAttribute('aria-invalid');
  selectBox.removeAttribute('aria-describedby');
}

document.addEventListener('change', function (e) {
  if (!e.target || e.target.id !== 'delivery_time') return;
  clearGuardError();
  postData();
});
window.addEventListener('load', postData);

// Returns true when the event was blocked because the delivery time isn't valid
function blockWithoutValidDeliveryTime(e, form) {
  const selectBox = getSelectBox();
  if (!selectBox) return false;

  clearGuardError();
  const message = getDeliveryTimeError(form);
  if (!message) return false;

  e.preventDefault();
  e.stopImmediatePropagation();

  const error = document.createElement('p');
  error.id = GUARD_ERROR_ID;
  error.className = 'Form__Alert Alert Alert--error cart-checkout-guard-error';
  error.setAttribute('role', 'alert');
  error.textContent = message;
  (selectBox.closest('.delivery_timeWrap') || selectBox).insertAdjacentElement('afterend', error);

  selectBox.setAttribute('aria-invalid', 'true');
  selectBox.setAttribute('aria-describedby', GUARD_ERROR_ID);
  selectBox.focus({ preventScroll: true });

  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  error.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  return true;
}

window.addEventListener('click', function (e) {
  const button = e.target.closest && e.target.closest('[name="checkout"]');
  if (!button || !button.form) return;
  blockWithoutValidDeliveryTime(e, button.form);
}, true);

// Same check for a submit that doesn't come from a click on the button (e.g. a script calling requestSubmit())
window.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form.querySelector || !form.querySelector('[name="checkout"]')) return;

  // loyalty.js flags the form before replaying its held submit; clear it when blocking so its validation isn't skipped next time
  if (blockWithoutValidDeliveryTime(e, form)) delete form.dataset.checkoutValidated;
}, true);
